import $ from 'jquery';
import JobAdElementsManager from 'JIX/jobad/elements/ElementsManager.js';

const stash = window.Stash.customlayout;

if (!window.Sentry) {
    // Provide a stub implementation
    window.Sentry = {
        captureException(err) {
            console.error(err);
        },
        captureMessage(msg) {
            console.error(msg);
        },
        setExtra() {},
        withScope(f) {
            const scope = {
                setExtra() {}
            };
            return f(scope);
        },
        is_stub: true,
    };
}

$(() => {
    const options = {
        defaultParams: {
            toolbar_variant: 'jobtext',
        },
    };
    if (typeof document.body.attachShadow === 'function') {
        const container = document.createElement('div');
        document.body.appendChild(container);

        const shadow = container.attachShadow({ mode: 'open' });

        const style = document.createElement('link');
        style.href = stash.bootstrapTheme;
        style.rel = 'stylesheet';
        shadow.appendChild(style);

        const svgs = document.querySelector('body > svg[hidden]');
        shadow.appendChild(svgs.cloneNode(true));

        const inner = document.createElement('div');
        shadow.appendChild(inner);

        options.container = inner;
    }

    const _manager = new JobAdElementsManager(options);
});

// Disable all event listeners registered by Bootstrap
$(document).off('.data-api');

// Cleanup globals required by this bundle and its dependencies. The
// dependencies are still available if imported into the bundle.
for (const k of ['jQuery', '$', 'bootbox']) {
    delete window[k];
}
